import React from "react";
import { connect } from "react-redux";
import { DeleteOutlined } from "@ant-design/icons";
import { requestToken } from "../actions/auth";
import { Col } from "antd";
import PopUp from "./PopUp";
import VerifyPopUp from "./VerifyPopUp";

//  isWebhook
//    ? `${this.props.data.value.value.substr(0, 32)}...`
//    : this.props.data.value.value;

class Tag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVerifyShown: false,
    };
  }

  openVerifyPopUp = () => {
    this.setState(() => ({
      isVerifyShown: true,
    }));
  };

  closeVerifyPopUp = () => {
    this.setState(() => ({
      isVerifyShown: false,
    }));
  };

  verify = async () => {
    const res = await this.props.requestToken(
      this.props.channel_type,
      this.props.data.value.value
    );
    if (res) {
      this.openVerifyPopUp();
    }
  };

  removeTag = () => {
    this.props.removeTag(this.props.id);
  };

  render() {
    const isPhone = this.props.channel_type === "phone";
    const isVerified = isPhone ? this.props.data.value.is_verified : true;
    return (
      <Col span={24} className="tag-input__tag">
        <p>
          {`${this.props.tagIndicator ? this.props.tagIndicator : ""}${
            this.props.data.value.value
          }`}
        </p>
        <button type="button" onClick={this.removeTag} className="delete">
          <DeleteOutlined />
        </button>
        {isVerified ? undefined : (
          <button
            type="button"
            onClick={this.verify}
            disabled={this.props.data.value.is_verified}
          >
            Verify
          </button>
        )}

        {this.state.isVerifyShown && (
          <PopUp
            className="popup-over-drawer"
            closePopUp={this.closeVerifyPopUp}
          >
            <VerifyPopUp
              value={this.props.data.value.value}
              channel_type={this.props.channel_type}
              closePopUp={this.closeVerifyPopUp}
            />
          </PopUp>
        )}
      </Col>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  requestToken: (channel_type, value) =>
    dispatch(requestToken(channel_type, value)),
});

export default connect(undefined, mapDispatchToProps)(Tag);
